import {
    Container,
    MainContentWrapper,
    MainContent,
    Heading
} from '../../styles/account/account'
import { DashboardWrapper } from '../../container/dashboardWrapper'
import { Input } from '../../components/input'
import { InputWrapper } from '../../components/input/input.style'
import { Button } from '../../components/button'
import { Breadcrumb } from '../../components/breadcrumb/breadcrumb'
import { Link } from 'react-router-dom';
import { ModuleHeader } from '../../components/module-header'
import { LibrarySubjects } from '../../components/library-subjects'
import { LibraryMedia } from '../../components/library-media'


const Library = () => {
    return (
        <DashboardWrapper>
            <MainContentWrapper fullHeight>
                <Container>
                    <MainContent>
                        <Heading>
                            Library
                        </Heading>
                        <Breadcrumb
                            crumbs={['My library']}
                        />
                        <ModuleHeader title="SCIENCE SUBJECTS" />
                        <LibrarySubjects />

                        <ModuleHeader title="MEDIA" />
                        <LibraryMedia />
                    </MainContent>
                </Container>
            </MainContentWrapper>
        </DashboardWrapper>
    )
}

export default Library
